"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  button: {
    position: 'relative',
    display: 'inline-flex',
    outline: 0,
    justifyContent: 'center',
    alignItems: 'center',
    boxSizing: 'border-box',
    borderRadius: theme.button.borderRadius,
    border: theme.button.border,
    borderStyle: 'solid',
    boxShadow: theme.button.boxShadow,
    transition: theme.transition(['background', 'border']),
    cursor: 'pointer',
    '&.hidden': {
      display: 'none'
    },
    padding: '0 15px',
    '& > span': {
      margin: '0 12px',
      lineHeight: '19px',
      position: 'relative',
      top: -1
    },
    '&.hideIcon > span': {
      marginLeft: 0
    },
    '&.hideIconAfter > span': {
      marginRight: 0
    },
    '&.hideLabel > span': {
      display: 'none'
    },
    '&.rounded': {
      borderRadius: '50%'
    }
  },
  default: Object.assign(theme.button.default.normal, {
    '&.disabled': {
      cursor: theme.button.default.disabled.cursor,
      backgroundColor: theme.button.default.disabled.backgroundColor,
      borderColor: theme.button.default.disabled.borderColor,
      color: theme.button.default.disabled.color
    },
    '&:not(.disabled):hover': {
      backgroundColor: theme.button.default.hover.backgroundColor,
      color: theme.button.default.hover.color,
      borderColor: theme.button.default.hover.borderColor
    },
    '&:not(.disabled):active, &:not(.disabled):focus': {
      backgroundColor: theme.button.default.normal.backgroundColor,
      color: theme.button.default.normal.color,
      borderColor: theme.button.default.normal.borderColor
    }
  }),
  secondary: Object.assign(theme.button.secondary.normal, {
    '&.disabled': {
      cursor: theme.button.secondary.disabled.cursor,
      backgroundColor: theme.button.secondary.disabled.backgroundColor,
      borderColor: theme.button.secondary.disabled.borderColor,
      color: theme.button.secondary.disabled.color
    },
    '&:not(.disabled):hover': {
      backgroundColor: theme.button.secondary.hover.backgroundColor,
      color: theme.button.secondary.hover.color,
      borderColor: theme.button.secondary.hover.borderColor
    },
    '&:not(.disabled):active, &:not(.disabled):focus': {
      backgroundColor: theme.button.secondary.normal.backgroundColor,
      color: theme.button.secondary.normal.color,
      borderColor: theme.button.secondary.normal.borderColor
    }
  }),
  tertiary: Object.assign(theme.button.tertiary.normal, {
    '&.disabled': {
      cursor: theme.button.tertiary.disabled.cursor,
      backgroundColor: theme.button.tertiary.disabled.backgroundColor,
      borderColor: theme.button.tertiary.disabled.borderColor,
      color: theme.button.tertiary.disabled.color,
      '& .fill': {
        fill: `${theme.button.tertiary.disabled.iconColor} !important`
      },
      '& .stroke': {
        stroke: `${theme.button.tertiary.disabled.iconColor} !important`
      }
    },
    '&:not(.disabled):hover': {
      backgroundColor: theme.button.tertiary.hover.backgroundColor,
      color: theme.button.tertiary.hover.color,
      borderColor: theme.button.tertiary.hover.borderColor,
      '& .fill': {
        fill: `${theme.button.tertiary.hover.iconColor} !important`
      },
      '& .stroke': {
        stroke: `${theme.button.tertiary.hover.iconColor} !important`
      }
    },
    '&:not(.disabled):active, &:not(.disabled):focus': {
      backgroundColor: theme.button.tertiary.normal.backgroundColor,
      color: theme.button.tertiary.normal.color,
      borderColor: theme.button.tertiary.normal.borderColor,
      '& .fill': {
        fill: `${theme.button.tertiary.normal.iconColor} !important`
      },
      '& .stroke': {
        stroke: `${theme.button.tertiary.normal.iconColor} !important`
      }
    }
  }),
  quaternary: Object.assign(theme.button.quaternary.normal, {
    '&.disabled': {
      cursor: theme.button.quaternary.disabled.cursor,
      backgroundColor: theme.button.quaternary.disabled.backgroundColor,
      borderColor: theme.button.quaternary.disabled.borderColor,
      color: theme.button.quaternary.disabled.color
    },
    '&:not(.disabled):hover': {
      backgroundColor: theme.button.quaternary.hover.backgroundColor,
      color: theme.button.quaternary.hover.color,
      borderColor: theme.button.quaternary.hover.borderColor
    },
    '&:not(.disabled):active, &:not(.disabled):focus': {
      backgroundColor: theme.button.quaternary.normal.backgroundColor,
      color: theme.button.quaternary.normal.color,
      borderColor: theme.button.quaternary.normal.borderColor
    }
  }),
  error: Object.assign(theme.button.error.normal, {
    '&.disabled': {
      cursor: theme.button.error.disabled.cursor,
      backgroundColor: theme.button.error.disabled.backgroundColor,
      borderColor: theme.button.error.disabled.borderColor,
      color: theme.button.error.disabled.color
    },
    '&:not(.disabled):hover': {
      backgroundColor: theme.button.error.hover.backgroundColor,
      color: theme.button.error.hover.color,
      borderColor: theme.button.error.hover.borderColor
    },
    '&:not(.disabled):active, &:not(.disabled):focus': {
      backgroundColor: theme.button.error.normal.backgroundColor,
      color: theme.button.error.normal.color,
      borderColor: theme.button.error.normal.borderColor
    }
  }),
  text: Object.assign(theme.button.text.normal, {
    '&.disabled': {
      cursor: theme.button.text.disabled.cursor,
      backgroundColor: theme.button.text.disabled.backgroundColor,
      borderColor: theme.button.text.disabled.borderColor,
      color: theme.button.text.disabled.color
    },
    '&:not(.disabled):hover': {
      backgroundColor: theme.button.text.hover.backgroundColor,
      color: theme.button.text.hover.color,
      borderColor: theme.button.text.hover.borderColor
    },
    '&:not(.disabled):active, &:not(.disabled):focus': {
      backgroundColor: theme.button.text.normal.backgroundColor,
      color: theme.button.text.normal.color,
      borderColor: theme.button.text.normal.borderColor
    }
  }),
  small: {
    height: 32,
    '&.hideLabel': {
      padding: '0 9px'
    }
  },
  smallplus: {
    height: 36,
    '&.hideLabel': {
      padding: '0 9px'
    }
  },
  medium: {
    height: 40,
    '&.hideLabel': {
      padding: '0 11px'
    }
  },
  large: {
    height: 44,
    padding: '0 23px',
    '&.hideLabel': {
      padding: '0 13px'
    }
  },
  menu: {
    position: 'absolute',
    left: 0,
    top: 'calc(100% + 4px)',
    color: theme.textColor // TODO доработать открытие вверх

  }
});

exports.default = _default;